
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2635',
  depVersions: {
  "customer-portal-app": "static-1.2635",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9771",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25703",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5700",
  "hs-test-utils": "static-1.8128",
  "hub-http": "static-1.6331",
  "hub-http-shared-msw-handlers": "static-1.10230",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18537",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11584",
  "I18n": "static-7.1637",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6567",
  "payment-link-components": "static-1.23814",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7166",
  "quartz-core": "static-1.6385",
  "quartz-i18n": "static-1.841",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10316",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5421",
  "rich-text-lib": "static-1.20018",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18142",
  "ui-components-test-utils": "static-1.5721",
  "UIComponents": "static-3.8530",
  "foundations-assets": "static-1.4982",
  "foundations-components": "static-1.8144",
  "foundations-theming": "static-1.4538",
  "foundations-theming-specialty": "static-1.2254",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1161",
  "quartz-config": "static-1.944",
  "quartz-routing": "static-1.596",
  "quick-fetch": "static-1.3997",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16792",
  "rpc-client-utils": "static-1.4764",
  "sanitize-text": "static-1.8253",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4868",
  "ui-addon-react-router-dom": "static-1.9646",
  "usage-tracker": "static-1.7457",
  "usage-tracker-anonymous": "static-1.5874",
  "usage-tracker-core": "static-1.7307",
  "video-components-external": "static-1.11633",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3477",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3443",
  "quartz-webpack": "static-1.3390",
  "bend-plugin-quartz-routing": "static-1.244",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7788",
  "frontend-preferences-client": "static-1.8036",
  "laboratory-lib": "static-3.7261",
  "onboarding-scopes": "static-1.6569",
  "seat-types-lib": "static-1.266",
  "ui-addon-opt": "static-4.8470",
  "HeadJS": "static-2.768",
  "hs-test-utils-bend-plugin": "static-1.3239",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.162",
  "ts-schema": "static-1.4160",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7924",
  "cssUtils": "static-1.823",
  "customer-data-ui-utilities": "static-1.9934",
  "HubStyle": "static-2.11891",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.9995",
  "ui-addon-i18n": "static-1.11257",
  "ui-business-units-lib": "static-1.9172",
  "ui-shepherd-react": "static-3.10337",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4434",
  "commerce-tours-lib": "static-1.6296",
  "customer-data-properties": "static-1.51955",
  "getting-started-shared-tasks": "static-1.18717",
  "growth-onboarding-reliability": "static-1.5189",
  "onboarding-tours": "static-1.16803",
  "reference-resolvers-lite": "static-1.8207",
  "sales-checkout-service-client": "static-1.3702",
  "ui-addon-iframeable": "static-1.9175",
  "user-context": "static-1.5218",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.844",
  "hubspotter-http": "static-1.4731",
  "icons": "static-2.653",
  "mobile-manifest-mixins": "static-1.543",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.841",
  "quartz-head": "static-1.831",
  "quartz-test": "static-1.841",
  "quartz-tracking": "static-1.545",
  "trellis-components": "static-1.2204",
  "ui-fonts": "static-1.846",
  "usage-tracker-container": "static-1.7447",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9530",
  "data-token-picker": "static-1.16597",
  "FileManagerLib": "static-1.39556",
  "property-translator": "static-1.5505",
  "atom": "static-1.5183",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6078",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5627",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-components": "static-1.4413",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2185",
  "bend-plugin-foundations-theming": "static-1.3021",
  "foundations-theming-base": "static-1.3523",
  "stylex": "static-1.34",
  "interframe": "static-3.4869",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5871",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.174",
  "chirp-fetch": "static-1.1995",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4584",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4760",
  "content-media-composition-data-lib": "static-1.12657",
  "content-media-compositions": "static-2.16664",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4259",
  "magpie-lib": "static-1.5623",
  "magpie-types": "static-1.5083",
  "media-bridge-lib": "static-1.19113",
  "video-data-lib": "static-1.35291",
  "bender-build-tools": "static-1.3281",
  "inbound-db-properties-service-client": "static-1.3925",
  "superstore": "static-1.4868",
  "feedback-loader": "static-1.29499",
  "ai-components-ui-library": "static-1.9226",
  "ui-addon-video-player": "static-1.8811",
  "ui-coaching-tips": "static-1.28864",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4724",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2606",
  "navigation-messaging": "static-1.7609",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8283",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9958",
  "crm-message-bus": "static-1.43270",
  "growth-data-modal": "static-1.5599",
  "hubspot-apollo-client": "static-1.4986",
  "onboarding-tours-client": "static-1.5017",
  "calling-global-api": "static-1.64891",
  "calling-internal-common": "static-1.31418",
  "calling-lifecycle-internal": "static-1.66273",
  "calling-lifecycle-messages": "static-1.58567",
  "conditional-properties-service-client": "static-1.3875",
  "crm-links": "static-1.6416",
  "crm-pipelines-api-client-types": "static-1.4217",
  "customer-data-objects-ui-components": "static-1.13139",
  "customer-data-properties-shared-msw-handlers": "static-1.9557",
  "customer-data-property-utils": "static-1.8203",
  "external-options-client-types": "static-1.4208",
  "file-manager-components": "static-1.23916",
  "framework-data-schema-resolvers": "static-1.7001",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.281",
  "inbound-db-meta-service-client": "static-1.3666",
  "inbounddb-objects-service-types": "static-1.4296",
  "meetings-icalendar-utils-lib": "static-1.742",
  "multi-currency-client-types": "static-1.3770",
  "object-builder-ui-client": "static-1.49123",
  "pipeline-validation-client-types": "static-1.4046",
  "property-value-citations": "static-1.2569",
  "pulse": "static-1.704",
  "smart-property-lib": "static-1.7762",
  "tiered-pricing": "static-1.1497",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11098",
  "growth-onboarding-confetti": "static-1.3174",
  "growth-onboarding-next-action-utils": "static-1.2238",
  "navigation-components": "static-1.18282",
  "onboarding-tours-utils": "static-1.869",
  "ui-shepherd-tracker": "static-1.7718",
  "ui-universal-auth": "static-1.9107",
  "batch-promise": "static-1.1651",
  "getting-started-shared-tasks-store": "static-1.17835",
  "hubspotter-http-shared-msw-handlers": "static-1.10228",
  "usage-tracker-session-replay": "static-1.5143",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1049",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6082",
  "FileManagerCore": "static-1.39415",
  "FileManagerImages": "static-1.37067",
  "video-components": "static-1.13635",
  "foundations-components-legacy": "static-1.1169",
  "purchase-motions-api": "static-1.6081",
  "signup-constants": "static-1.19103",
  "signup-ui-url-generator": "static-2.8166",
  "usage-tracker-public": "static-1.7268",
  "reactive-lib": "static-1.834",
  "simple-logging-lib": "static-1.3158",
  "chatspot-core": "static-1.21812",
  "ContentUtils": "static-1.68673",
  "copilot-toolkit": "static-1.11414",
  "growth-onboarding-feedback-components": "static-1.6688",
  "commerce-permissions": "static-1.885",
  "customer-data-tracking": "static-1.6997",
  "products-iframe-lib": "static-1.8237",
  "products-ui-components-shared-msw-handlers": "static-1.10612",
  "restore-request-side-panel-lib": "static-1.1149",
  "onboarding-data-sync-lib": "static-1.2146",
  "hubspot-apollo-cache": "static-1.445",
  "calling-error-reporting": "static-1.31425",
  "shared-worker-versioning": "static-1.11144",
  "calling-usage-tracker": "static-1.6651",
  "voice-sms-access-library": "static-1.1420",
  "conversations-skeleton-state": "static-1.7356",
  "location-customization-utils-lib": "static-1.9583",
  "fdsr-migration-layer": "static-1.120",
  "framework-builder-read-service-client": "static-1.4084",
  "framework-data-schema-quick-fetch": "static-1.6906",
  "persist-promise": "static-1.3808",
  "event-emitter": "static-1.1058",
  "bend-plugin-pulse": "static-1.207",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.370",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10313",
  "fsm": "static-1.3837",
  "policy-lib": "static-1.6890",
  "react-tinymce": "static-1.55530",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10376",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54656",
  "tinymce-plugins": "static-1.57770",
  "tinymce-themes": "static-1.56626",
  "growth-onboarding-next-action-components": "static-1.2266",
  "user-context-client": "static-1.4689",
  "nest": "static-1.341",
  "unified-auth-core-lib": "static-1.903",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4644",
  "video-embed": "static-1.36125",
  "content-icons-ui": "static-1.2257",
  "social-insights-client-types": "static-1.22323",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4923",
  "integrations-lib": "static-1.16509",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.1094",
  "sales-views-client-types": "static-1.4365",
  "InboxConnectUtils": "static-4.15096",
  "meetings-connect-utils-lib": "static-1.7714",
  "calling-orchestration-schema": "static-1.36197",
  "crm-record-cards-service-types": "static-1.3669",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4621",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3152",
  "tinymce-data": "static-1.40741",
  "ui-addon-sales-email": "static-1.5318",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12651",
  "layout-dnd-utils": "static-1.11626",
  "react-codemirror": "static-1.10736",
  "ui-brand-identity-lib": "static-1.15670",
  "NamespacedHubStyle": "static-2.9135",
  "outpost": "static-1.4279",
  "flux-actions": "static-1.345",
  "integrations-error-boundary-lib": "static-1.13924",
  "integrations-tracking-lib": "static-1.5715",
  "native-integrations-shared-strings": "static-1.7891",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10471",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.621",
  "breeze-engine-core": "static-1.372",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68748",
  "layout-data-lib": "static-1.9951",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3126",
  "ads-unified-auth-lib": "static-1.353",
  "google-sheets-integration-lib": "static-1.559",
  "microsoft-drive-integration-lib": "static-1.697",
  "surveymonkey-integration-lib": "static-1.24",
  "slack-ui-library": "static-1.10503",
  "advanced-menus-core": "static-1.15303",
  "advanced-menus-lib": "static-1.12216",
  "ExportDialog": "static-6.10488",
  "ui-memberships-settings-lib": "static-1.34339",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15302",
  "simple-menus-lib": "static-1.16819"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2635",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9771",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25703",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5700",
  "hs-test-utils": "/hs-test-utils/static-1.8128",
  "hub-http": "/hub-http/static-1.6331",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10230",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18537",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11584",
  "I18n": "/I18n/static-7.1637",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6567",
  "payment-link-components": "/payment-link-components/static-1.23814",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7166",
  "quartz-core": "/quartz-core/static-1.6385",
  "quartz-i18n": "/quartz-i18n/static-1.841",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10316",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5421",
  "rich-text-lib": "/rich-text-lib/static-1.20018",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18142",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5721",
  "UIComponents": "/UIComponents/static-3.8530",
  "foundations-assets": "/foundations-assets/static-1.4982",
  "foundations-components": "/foundations-components/static-1.8144",
  "foundations-theming": "/foundations-theming/static-1.4538",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2254",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1161",
  "quartz-config": "/quartz-config/static-1.944",
  "quartz-routing": "/quartz-routing/static-1.596",
  "quick-fetch": "/quick-fetch/static-1.3997",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16792",
  "rpc-client-utils": "/rpc-client-utils/static-1.4764",
  "sanitize-text": "/sanitize-text/static-1.8253",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4868",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9646",
  "usage-tracker": "/usage-tracker/static-1.7457",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5874",
  "usage-tracker-core": "/usage-tracker-core/static-1.7307",
  "video-components-external": "/video-components-external/static-1.11633",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3477",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3443",
  "quartz-webpack": "/quartz-webpack/static-1.3390",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.244",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7788",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8036",
  "laboratory-lib": "/laboratory-lib/static-3.7261",
  "onboarding-scopes": "/onboarding-scopes/static-1.6569",
  "seat-types-lib": "/seat-types-lib/static-1.266",
  "ui-addon-opt": "/ui-addon-opt/static-4.8470",
  "HeadJS": "/HeadJS/static-2.768",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3239",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.162",
  "ts-schema": "/ts-schema/static-1.4160",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7924",
  "cssUtils": "/cssUtils/static-1.823",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9934",
  "HubStyle": "/HubStyle/static-2.11891",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9995",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11257",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9172",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10337",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4434",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6296",
  "customer-data-properties": "/customer-data-properties/static-1.51955",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18717",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5189",
  "onboarding-tours": "/onboarding-tours/static-1.16803",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8207",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3702",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9175",
  "user-context": "/user-context/static-1.5218",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.844",
  "hubspotter-http": "/hubspotter-http/static-1.4731",
  "icons": "/icons/static-2.653",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.543",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.841",
  "quartz-head": "/quartz-head/static-1.831",
  "quartz-test": "/quartz-test/static-1.841",
  "quartz-tracking": "/quartz-tracking/static-1.545",
  "trellis-components": "/trellis-components/static-1.2204",
  "ui-fonts": "/ui-fonts/static-1.846",
  "usage-tracker-container": "/usage-tracker-container/static-1.7447",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9530",
  "data-token-picker": "/data-token-picker/static-1.16597",
  "FileManagerLib": "/FileManagerLib/static-1.39556",
  "property-translator": "/property-translator/static-1.5505",
  "atom": "/atom/static-1.5183",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6078",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5627",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4413",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2185",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3021",
  "foundations-theming-base": "/foundations-theming-base/static-1.3523",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4869",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5871",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.174",
  "chirp-fetch": "/chirp-fetch/static-1.1995",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4584",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4760",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12657",
  "content-media-compositions": "/content-media-compositions/static-2.16664",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4259",
  "magpie-lib": "/magpie-lib/static-1.5623",
  "magpie-types": "/magpie-types/static-1.5083",
  "media-bridge-lib": "/media-bridge-lib/static-1.19113",
  "video-data-lib": "/video-data-lib/static-1.35291",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3925",
  "superstore": "/superstore/static-1.4868",
  "feedback-loader": "/feedback-loader/static-1.29499",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9226",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8811",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28864",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4724",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2606",
  "navigation-messaging": "/navigation-messaging/static-1.7609",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8283",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9958",
  "crm-message-bus": "/crm-message-bus/static-1.43270",
  "growth-data-modal": "/growth-data-modal/static-1.5599",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4986",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5017",
  "calling-global-api": "/calling-global-api/static-1.64891",
  "calling-internal-common": "/calling-internal-common/static-1.31418",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66273",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58567",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3875",
  "crm-links": "/crm-links/static-1.6416",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4217",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13139",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9557",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8203",
  "external-options-client-types": "/external-options-client-types/static-1.4208",
  "file-manager-components": "/file-manager-components/static-1.23916",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7001",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.281",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3666",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4296",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.742",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3770",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49123",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4046",
  "property-value-citations": "/property-value-citations/static-1.2569",
  "pulse": "/pulse/static-1.704",
  "smart-property-lib": "/smart-property-lib/static-1.7762",
  "tiered-pricing": "/tiered-pricing/static-1.1497",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11098",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3174",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2238",
  "navigation-components": "/navigation-components/static-1.18282",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.869",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7718",
  "ui-universal-auth": "/ui-universal-auth/static-1.9107",
  "batch-promise": "/batch-promise/static-1.1651",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17835",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10228",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5143",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1049",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6082",
  "FileManagerCore": "/FileManagerCore/static-1.39415",
  "FileManagerImages": "/FileManagerImages/static-1.37067",
  "video-components": "/video-components/static-1.13635",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1169",
  "purchase-motions-api": "/purchase-motions-api/static-1.6081",
  "signup-constants": "/signup-constants/static-1.19103",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8166",
  "usage-tracker-public": "/usage-tracker-public/static-1.7268",
  "reactive-lib": "/reactive-lib/static-1.834",
  "simple-logging-lib": "/simple-logging-lib/static-1.3158",
  "chatspot-core": "/chatspot-core/static-1.21812",
  "ContentUtils": "/ContentUtils/static-1.68673",
  "copilot-toolkit": "/copilot-toolkit/static-1.11414",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6688",
  "commerce-permissions": "/commerce-permissions/static-1.885",
  "customer-data-tracking": "/customer-data-tracking/static-1.6997",
  "products-iframe-lib": "/products-iframe-lib/static-1.8237",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10612",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1149",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2146",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.445",
  "calling-error-reporting": "/calling-error-reporting/static-1.31425",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11144",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6651",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1420",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7356",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9583",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.120",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4084",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6906",
  "persist-promise": "/persist-promise/static-1.3808",
  "event-emitter": "/event-emitter/static-1.1058",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.207",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.370",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10313",
  "fsm": "/fsm/static-1.3837",
  "policy-lib": "/policy-lib/static-1.6890",
  "react-tinymce": "/react-tinymce/static-1.55530",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10376",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54656",
  "tinymce-plugins": "/tinymce-plugins/static-1.57770",
  "tinymce-themes": "/tinymce-themes/static-1.56626",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2266",
  "user-context-client": "/user-context-client/static-1.4689",
  "nest": "/nest/static-1.341",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.903",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4644",
  "video-embed": "/video-embed/static-1.36125",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4923",
  "integrations-lib": "/integrations-lib/static-1.16509",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1094",
  "sales-views-client-types": "/sales-views-client-types/static-1.4365",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15096",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7714",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36197",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3669",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4621",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3152",
  "tinymce-data": "/tinymce-data/static-1.40741",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5318",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12651",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11626",
  "react-codemirror": "/react-codemirror/static-1.10736",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15670",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9135",
  "outpost": "/outpost/static-1.4279",
  "flux-actions": "/flux-actions/static-1.345",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13924",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5715",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7891",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10471",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.621",
  "breeze-engine-core": "/breeze-engine-core/static-1.372",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68748",
  "layout-data-lib": "/layout-data-lib/static-1.9951",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3126",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.353",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.559",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.697",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.24",
  "slack-ui-library": "/slack-ui-library/static-1.10503",
  "advanced-menus-core": "/advanced-menus-core/static-1.15303",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12216",
  "ExportDialog": "/ExportDialog/static-6.10488",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34339",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15302",
  "simple-menus-lib": "/simple-menus-lib/static-1.16819"
}
};
